// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store/store";
import router from "./router";
import Firebase from "./firebase";
import VueFormulate from "@braid/vue-formulate";

Vue.use(VueFormulate);
Vue.config.productionTip = false;
Firebase.init();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store: store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js